// export const BASE_URL_API = 'https://cors-anywhere.herokuapp.com/https://rate.lokaci.com/andromeda/apis/';
export const BASE_URL_API = 'https://rate.lokaci.com/andromeda/apis/';